/* global i18n */

import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
// import { pathEq, filter, compose, flatten, values } from 'ramda'
// import { isNotEmpty } from 'ramda-adjunct'
import Button from '../../../../components/Button/Button.jsx'
import { xhrPost } from '../../../../helpers/http.js'
import { baseUrl } from '../../../../common/constants.js'

const AbortPayment = () => {
  const dispatch = useDispatch()

  const isUnderPayment = useSelector((state) => state.Cart.isUnderPayment)
  const setIsLoading = (isLoading) => {
    dispatch({
      type: 'Cart.setIsLoading',
      payload: {
        isLoading
      }
    })
  }

  const setItems = (items) => {
    dispatch({
      type: 'Cart.setItems',
      payload: {
        items
      }
    })
  }

  const setIsUnderPayment = (isUnderPayment) => {
    dispatch({
      type: 'Cart.setIsUnderPayment',
      payload: {
        isUnderPayment
      }
    })
  }

  const apiAbortPayment = async () => {
    return xhrPost(`${baseUrl}/web/cart/payment/abort`)
  }

  const abortPayment = async () => {
    setIsLoading(true)
    setItems(await apiAbortPayment())
    setIsUnderPayment(false)
    setIsLoading(false)
  }

  return (
    <>
      {isUnderPayment && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={abortPayment} color="red">
            {i18n.t('cart_abort_payment')}
          </Button>
        </div>
      )}
    </>
  )
}

export default AbortPayment
